import { render, staticRenderFns } from "./sharebutton.vue?vue&type=template&id=5e496da0&"
import script from "./sharebutton.vue?vue&type=script&lang=js&"
export * from "./sharebutton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports